// 丹麦语
import da from '../JsonLang/da.json'
import enSpec from '../JsonLangSpec/en.json'
export const lang = {
  ...da, ...enSpec
}
